module.exports = __webpack_public_path__ + "static/monetize-tile-4-2-e4c57fd080377e3332d78aa966ffb1db.png";